module.exports = __webpack_public_path__ + "img/android.4de66705.png";